import { createContext, useContext } from 'react'

type LangContextType = {
  lang: string | null
  setLang: (value: string | null) => void
}

export const LangContext = createContext<LangContextType>({
  lang: null,
  setLang: () => {},
})

export const useLang = () => {
  const context = useContext(LangContext)

  return context
}
